import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { GETInventoryService } from '../../../services/inventory.service';
import { ImplementDetailsService } from '../../../implement-details/implement-details.service';
import { ImplementCycleDetails, UpdateImplementTargets } from '../../../add-observation-point/add-observation-point-modal';
import { ErrorCode, ErrorMessages } from '../../../entities/global/error-codes';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-implement-targets-update',
  templateUrl: './implement-targets-update.component.html',
  styleUrls: ['./implement-targets-update.component.css']
})
export class ImplementTargetsUpdateComponent implements OnInit {

  implementId:number
  implementName:string
  customerID:number
  jobsiteId:number;
  jobsiteName:string;
  startDate:Date;
  CycleDetails:ImplementCycleDetails;
  cycleNo:number=0;
  hours:number;
  bcm:number;
  tons:number;
  savingChanges:boolean=false;
  oldhours:number;
  oldbcm:number;
  oldtons:number;
  cycleId:number;
  constructor(private dialogRef: MatDialogRef<ImplementTargetsUpdateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _inventoryService: GETInventoryService,
    public addRepairerWorkshopModal: MatDialog,
    public _implementService: ImplementDetailsService,
     public toastr: NotificationsService, vcr: ViewContainerRef) {
    
    }

  ngOnInit() {
    if(this.data != null){
      this.implementId=this.data.implementId;
      this.customerID=this.data.customerId;
      this.implementName =this.data.implementName;
      this.jobsiteId=this.data.jobsiteId;
      this.jobsiteName=this.data.jobsiteName;
    }

    this.getCycleDetails();
  }

   //Load Current Cycle Details
   getCycleDetails(){
    this._implementService.GetCurrentCycleDetails(this.implementId).subscribe(response=>{
      console.log(response)
      this.CycleDetails=response;
      this.startDate = this.CycleDetails.StartDate;
      this.cycleNo=this.CycleDetails.CycleNo;
      this.bcm=this.CycleDetails.BCM;
      this.tons=this.CycleDetails.Tons;
      this.hours=this.CycleDetails.Hours;
      this.oldbcm=this.CycleDetails.BCM;
      this.oldtons=this.CycleDetails.Tons;
      this.oldhours=this.CycleDetails.Hours;
      this.cycleId=this.CycleDetails.Id;
    })
  }

onCloseClick(): void {
    this.dialogRef.close();
  }


  saveChanges(){
    if (this.savingChanges) {
      return;
  }

  let validation = this.validateData();
  this.savingChanges = true;
  if (validation == ErrorCode.VALIDATION_PASSED) {
    var params: UpdateImplementTargets = new UpdateImplementTargets();
        params.ImplementId = this.implementId;
        params.NewHours=this.hours;
        params.NewBCM=this.bcm;
        params.NewTons=this.tons;
        params.CycleNo=this.cycleNo;
        params.Hours=this.oldhours;
        params.BCM=this.oldbcm;
        params.Tons=this.oldtons;
        params.CycleId=this.cycleId;
        
    this._implementService.UpdateImplementTargets(params).subscribe(response=>{
      console.log("response", response)
      if(response){
        this.dialogRef.close();
      }
    })
  }else{
    this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
    this.savingChanges = false;
  }
  }

  validateData(): number {
    var returnCode = ErrorCode.ERROR_MISSING_FIELDS;
        if (this.implementId
            && this.hours >=0
            && this.bcm >=0
            && this.tons >=0) {
              returnCode = ErrorCode.VALIDATION_PASSED;
        }
    return returnCode;
  }
}
